import { render } from "./m-card-result.vue?vue&type=template&id=665708b7&scoped=true&ts=true"
import script from "./m-card-result.vue?vue&type=script&lang=ts"
export * from "./m-card-result.vue?vue&type=script&lang=ts"

import "./m-card-result.vue?vue&type=style&index=0&id=665708b7&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-665708b7"]])

export default __exports__